import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconLetterACircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLetterACircle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M8.35938 16L11.4766 7.54492H12.5195L15.6367 16H14.5293L13.6797 13.5801H10.3164L9.4668 16H8.35938ZM11.9512 8.91016L10.627 12.6836H13.3691L12.0449 8.91016H11.9512Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLetterACircle;
